import { ActionReducerMap } from '@ngrx/store';

export interface RootState {}

export const rootReducers: ActionReducerMap<RootState> = {};
